var lang = {
    "en":{
        menuText1: "INTRO",
        menuText2: "CHALLENGE",
        menuText3: "Challenge",
        countdown: "Upcoming countdown",
        day: "Day",
        hour: "Hour",
        minute: "Minute",
        second: "Second",
        subBtnText1: "Subscribe the upcoming",
        subBtnText2: "Cancel subscription",
        challengeText: "Select your favorite challenge and vote to it. Host will perform it in next live!",
        vote: "Vote",
        follow: "Follow",
        following: "Following",
        recommendText: "Hosts you may like",
    },
    "ar":{
        menuText1: "تقديم",
        menuText2: "تحدي",
        menuText3: "تحدي",
        countdown: "العد التنازلي للبث المباشر",
        day: "يوم",
        hour: "ساعة",
        minute: "دقيقة",
        second: "ثانية",
        subBtnText1: "سجل في الجدولة",
        subBtnText2: "إلغاء التسجيل",
        challengeText: "حدد التحدي المفضل لديك وصوت له. وسيقوم المضيف بأدائه في البث المباشر القادم!",
        vote: "صوت",
        follow: "تابع",
        following: "متابع",
        recommendText: "مضيف موصى بهم",
    }
}

export {lang}


// WEBPACK FOOTER //
// ./src/language/kol.js